import { useState, useEffect } from 'react';
import { api } from '../../../utils/api';

const gbp = cents => (cents == null ? '—' : `£${(cents / 100).toFixed(0)}`);

const DEBOUNCE_MS = 350;

export default function PastItemsPopup({ title, onClose, onOpenDeal }) {
    // The term seeds from the item name but is the operator's to edit — they can
    // broaden or correct the query and re-research without leaving the card.
    // `title` only seeds; the field owns the term after that.
    const [term, setTerm] = useState(title);
    const [state, setState] = useState({ loading: true });

    useEffect(() => {
        const q = term.trim();
        if (!q) { setState({ loading: false, results: [], truncated: false }); return; }
        let alive = true;
        // Debounce so an as-you-type edit fires one search when typing settles,
        // not one per keystroke. The cleanup cancels the pending search AND
        // ignores a slow response from a superseded term.
        const timer = setTimeout(() => {
            setState({ loading: true });
            api.get(`/api/deals/search?q=${encodeURIComponent(q)}`)
                .then(r => { if (alive) setState({ loading: false, results: r.results || [], truncated: r.truncated }); })
                .catch(e => { if (alive) setState({ loading: false, error: e.message || 'Search failed' }); });
        }, DEBOUNCE_MS);
        return () => { alive = false; clearTimeout(timer); };
    }, [term]);

    useEffect(() => {
        const onKey = e => { if (e.key === 'Escape') onClose(); };
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, [onClose]);

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content qa-past" onClick={e => e.stopPropagation()}>
                <div className="modal-header">
                    <h3>Past items</h3>
                    <button className="modal-close" onClick={onClose} aria-label="Close">×</button>
                </div>
                <div className="modal-body-scroll">
                    <input
                        className="qa-past-search"
                        type="text"
                        aria-label="Search past items"
                        placeholder="Search past items by name"
                        value={term}
                        onChange={e => setTerm(e.target.value)}
                        autoFocus
                    />
                    {state.loading && <div className="qa-muted">Searching…</div>}
                    {state.error && <div className="qa-error" role="alert">{state.error}</div>}
                    {!state.loading && !state.error && state.results.length === 0 &&
                        <div className="qa-muted">No past items found.</div>}
                    {!state.loading && !state.error && state.results.map((r, i) => (
                        <div key={i} className="qa-past-row">
                            <span className={`qa-past-id ${onOpenDeal && r.hubspot_deal_id ? 'qa-link' : ''}`}
                                onClick={() => onOpenDeal && r.hubspot_deal_id && onOpenDeal(r.hubspot_deal_id)}>
                                {r.hubspot_deal_id || '—'}
                            </span>
                            <span className="qa-past-name">{r.item_name || '—'}</span>
                            <span className="qa-past-sp">SP {gbp(r.sell_price_cents)}</span>
                            <span className="qa-past-bp">BP {gbp(r.buy_price_cents)}</span>
                            <span className="qa-muted">{r.condition || ''}</span>
                            <span className="qa-muted">{r.deal_create_date ? String(r.deal_create_date).slice(0, 10) : ''}</span>
                            <span className="qa-muted qa-past-email">{r.contact_email || ''}</span>
                            <span className="qa-past-stage">{r.deal_stage_label || ''}</span>
                        </div>
                    ))}
                    {state.truncated && <div className="qa-muted">Showing first 500 matches.</div>}
                </div>
            </div>
        </div>
    );
}
